import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';

import GroupModel    from 'GroupModel.js';
import GroupControlView from 'common-visuals/GroupControlView.js';

//=============================================================================
//
// Creates a group control, given a factoryService
// parameter key and a layout position. The factory key defines the initial
// rectangle of the control via a width and height from the factory parameter.
//
//=============================================================================
class ControlGroupFactory extends BaseVisualControlFactory {
    constructor () {
        super();
    }

    createView( factoryKey, pos ) {

        const attributes = this.createChildAttributes(  factoryKey, pos ) ;
        attributes.silent = false;

        // attributes for header
        attributes.backgroundColor = '~groupBgColor';
        attributes.titleColor ='~groupTextColor';
        attributes.titleFontFamily = '~groupFont';
        attributes.titleFontSize = '~groupFont';
        attributes.titleTextWeight = '~groupFont';
        attributes.titleTextStyle  = '~groupFont';
        attributes.titleBackgroundColor = '~groupTitleBg';
        attributes.hasTitle = 'false';
        attributes.titleText = 'Group';
        attributes.titleHeight = '25';
        attributes.showGroupHeader = 'hide';
        attributes.titleAlign ='left';
        attributes.alignLeftSelection = 'lightgrey';
        attributes.alignCenterSelection = 'transparent';
        attributes.alignRightSelection = 'transparent';
        attributes.titleBoldSelection = 'transparent';
        attributes.titleItalicSelection = 'transparent';

        // attributes for group
        attributes.borderStyle= '~groupBorder';
        attributes.borderSize= '~groupBorder';
        attributes.cornerRadius= '~groupBorder';
        attributes.borderColor = '~groupBorderColor';
        //attributes.styleBGColorText = '~groupBgColor';
        attributes.bgImage = '~groupBgImage';
        attributes.transparentBackground = '~groupBgTransparent';
        attributes.groupBackgroundImageTag = '';
        attributes.groupBackgroundImageStyle = '';
        attributes.backgroundImageAssetId = '~groupBgImage';
		attributes.minWidth = 45;
		attributes.lowestHeight = 10;

        attributes.translateProps = [
            {key:"titleText", label:"Title Text"},
            {key:"obligatoryMessage", label:"Mandatory Message"},
            {key:"toolTip", label:"Tooltip"},
            {key:"accessDesc", label:"Accessibility Description"},
        ];

        this.resolveForInitialMinHeight(attributes);

        attributes.childList = [];

        return new GroupControlView( { model: new GroupModel( attributes ), el: $(constants.FORM_ID),
            pos: pos, factoryKey: factoryKey, id: attributes.id } );
    }

}

const controlGroupFactory = new ControlGroupFactory();
export default controlGroupFactory;
